// Assuming you have a function to fetch cart data
function fetchCartData() {
  return fetch('/cart.js')
    .then((response) => response.json())
    .catch((error) => console.error('Error fetching cart data:', error));
}

// Updates cart data
async function updateCartItem(formData, key) {
  fetch('/cart/update.js', {
    method: 'POST',
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(`NEW Updated quantity for item key ${key}.`);
      handleCartUpdates();
    })
    .catch((error) => {
      console.error('NEW Error updating cart item quantity:', error);
      location.reload()
    });
}

// Adds product to cart from product page
function addAddonToCart(addonId, quantity, parentTitle, parentId, parentKey) {
  const formData = new FormData();
  formData.append('id', addonId);
  formData.append('quantity', quantity);
  formData.append('properties[Bundled with]', parentTitle);
  formData.append('properties[_parent_id]', parentId);
  formData.append('properties[_parent_key]', parentKey)

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(`Addon added: ID ${data.product_id}, Title ${data.product_title}, Qty: ${data.quantity}, ParentID: ${parentId}`);
      handleCartUpdates();
    })
    .catch((error) => console.error('Error adding addon to cart:', error));
}

function disableCheckoutButtons() {
  const cartDrawer = document.querySelector('.main-cart');
  if (window.wholesale) {
    const cartCheckoutButton = cartDrawer.querySelector('.cart__checkout-button')
    cartCheckoutButton.classList.add('loading')
  }
  cartDrawer.setAttribute('disabled', '');
}

async function enableCheckoutButton() {
  setTimeout(() => {
    // console.log('Checkout buttons enabled after delay.');
    const cartDrawer = document.querySelector('.main-cart');
    cartDrawer.removeAttribute('disabled');
    if (window.location.pathname === '/cart') {
      const cartCheckoutButton = cartDrawer.querySelector('.cart__checkout-button')
      cartCheckoutButton.classList.remove('loading')
    }
  }, 250);
}

// Global state to track if the cart is synced
let coresAreSynced = false;
let shippingSynced = false;

function findApplicableShippingVariant(cartTotal) {
  const applicableVariant = shippingProducts.find((variant) => {
    const priceFirst = parseFloat(variant.priceFirst);
    const priceLast = parseFloat(variant.priceLast);
    return cartTotal >= priceFirst && cartTotal <= priceLast;
  });

  return applicableVariant ? applicableVariant.id : null;
}

async function checkShippingInsurance(addShipping) {
  try {
    const cart = await fetchCartData(); // Assume this function fetches the latest cart data
    shippingSynced = true;

    // Non-Insurance Items
    const normalItems = cart.items.filter(
      (item) => item.product_type !== 'Shipping_Insurance'
    );
    // console.log('Normal Items Array Length', normalItems.length);
    if (normalItems.length) {
      let excludedPrices = 0;
      cart.items.forEach((item) => {
        if (
          item.product_type === 'Shipping_Insurance' ||
          item.product_type === 'mws_fee_generated' ||
          item.product_type === 'Tune Files' ||
          item.product_type === 'TCM Tune Files' ||
          item.product_type === 'Gift Cards'
        ) {
          excludedPrices += item.original_line_price;
        }
      });
      const totalPrice = cart.original_total_price;
      var cartTotalFiltered = (totalPrice - excludedPrices) / 100;

      // console.log('Total Cart', totalPrice / 100);
      // console.log('Excluded Prices', excludedPrices / 100);
      // console.log('Filtered', cartTotalFiltered);

      // Find the appropriate shipping variant ID
      var shippingVariantId = findApplicableShippingVariant(cartTotalFiltered);
      // console.log('Applicable Shipping Variant ID:', shippingVariantId);
    }

    const insuranceItems = cart.items.filter(
      (item) => item.product_type === 'Shipping_Insurance'
    );

    if (addShipping && normalItems.length && cartTotalFiltered) {
      // If Add Shipping is true and no insurance items, add appropriate shipping item
      if (insuranceItems.length === 0) {
        shippingSynced = false;
        // console.log('Adding shipping insurance to cart.', shippingVariantId);
        addAddonToCart(shippingVariantId, 1, '', '', '');
      } else {
        for (const item of insuranceItems) {
          // console.log('Insurance Items Variant Id:', item.id);
          // console.log('shippingVariantId is:', shippingVariantId);
          // console.log('Item Quantity', item.quantity);

          if (item.id !== shippingVariantId || insuranceItems.length > 1) {
            shippingSynced = false;
            // console.log('Item ID does not match Insurance Id or length is greater han 1.');
            const formData = new FormData();
            formData.append('updates[' + item.key + ']', 0);
            await updateCartItem(formData, item.key);
          } else if (item.quantity > 1) {
            shippingSynced = false;
            // console.log(`Shipping item Qty is: ${item.quantity}. Reducing ${item.key} Qty to 1.`);
            const formData = new FormData();
            formData.append('updates[' + item.key + ']', 1);
            await updateCartItem(formData, item.key);
            // console.log('Multiple shipping items found, setting qty to 1');
          }
        }
      }
      // If Addshiping is False, remove all insurnace items
    } else {
      // console.log('Removing all shipping insurance items if any.');
      for (const item of insuranceItems) {
        shippingSynced = false;
        const formData = new FormData();
        formData.append('updates[' + item.key + ']', 0); // Set quantity to zero to remove the item
        await updateCartItem(formData, item.key);
      }
    }
  } catch (error) {
    console.error('Error fetching or processing shipping cart data:', error);
    shippingSynced = false; // Ensure sync status is accurate on error
  }
}
async function checkCoreProducts() {
  try {
    const cart = await fetchCartData();
    coresAreSynced = true; // Assume synced until proven otherwise

    // console.log('Full Cart Data:', cart);

    // Extract current parent keys from the cart
    const currentParentKeys = new Set(
      cart.items
        .filter((item) => item.properties && item.properties._core_id)
        .map((item) => item.key)
    );

    // console.log('Current Parent Keys:', Array.from(currentParentKeys));

    for (const productItem of cart.items) {
      if (productItem.properties && productItem.properties._core_id) {
        // console.log(`Checking product: ID ${productItem.id}, Title ${productItem.title}, Key: ${productItem.key}`);

        // Find the add-on using the line item key stored in properties
        const addonExists = cart.items.find(
          (item) =>
            item.properties &&
            item.properties._parent_key === productItem.key
        );

        if (!addonExists) {
          // console.log(`No addon found for main product Key ${productItem.key}. Adding addon...`);
          coresAreSynced = false;
          await addAddonToCart(
            productItem.properties._core_id,
            productItem.quantity,
            productItem.title,
            productItem.id,
            productItem.key  // Now passing the parent's key as a property for the addon
          );
        } else {
          // console.log(`Addon exists for product Key ${productItem.key}, checking quantity...`);
          if (addonExists.quantity !== productItem.quantity) {
            // console.log(`Quantity mismatch for product Key ${productItem.key}, updating...`);
            coresAreSynced = false;
            const formData = new FormData();
            formData.append('updates[' + addonExists.key + ']', productItem.quantity);  // Correctly update to the desired quantity
            await updateCartItem(formData, addonExists.key);
          }
        }
      } else if (
        productItem.product_type === 'mws_fee_generated' &&
        (!productItem.properties._parent_key ||
          !currentParentKeys.has(productItem.properties._parent_key))
      ) {
        // console.log(`Orphan product found: ${productItem.title}, removing...`);
        coresAreSynced = false;
        const formData = new FormData();
        formData.append('updates[' + productItem.key + ']', 0);
        await updateCartItem(formData, productItem.key);
      }
    }
  } catch (error) {
    console.error('Error fetching or processing cart data:', error);
    coresAreSynced = false; // Set false to reflect the error state
  }
}

var shippingClicked = '';
// Click Add Shipping Insurance Button
async function clickShippingToggle() {
  disableCheckoutButtons();
  const cartDrawer = document.querySelector('.main-cart');
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (event) {
      const shippingButton = event.target.closest('.shipping-check');
      if (shippingButton) {
        // Used to refresh the page for the WCP app when shipping and cores are done syncing
        shippingClicked = true;

        disableCheckoutButtons();
        toggleShippingStatus();
        const addShipping = getShippingStatus();

        const formData = new FormData();
        formData.append(
          'attributes[include_shipping_insurance]',
          addShipping.toString()
        );
        updateCartItem(formData, '');
        // console.log(`Shipping insurance attribute updated to match local storage: ${addShipping}`);
        if (addShipping) {
          shippingButton.classList.add('checked');
        } else {
          shippingButton.classList.remove('checked');
        }
      }
    });
  }
}

// Toggles localstorage
function toggleShippingStatus() {
  const key = 'Include Shipping Insurance';
  let currentState = localStorage.getItem(key) === 'true';
  let newState = !currentState;
  localStorage.setItem(key, newState.toString()); // Make sure to store the string version of the boolean
  // console.log(`Updated shipping insurance in localStorage to: ${newState}`); // Debug output
  return newState;
}
// Grab current localstorage
function getShippingStatus() {
  const key = 'Include Shipping Insurance';
  let currentState = localStorage.getItem(key) === 'true';
  return currentState;
}

async function handleCartUpdates() {
  disableCheckoutButtons();
  await checkCoreProducts();

  if (coresAreSynced) {
    const addShipping = getShippingStatus();
    await checkShippingInsurance(addShipping);
  }

  // console.log('Is cores synced?', coresAreSynced);
  // console.log('Is shipping synced?', shippingSynced);

  // Only proceed with cart updates if the global sync status indicates everything is in sync
  if (coresAreSynced && shippingSynced) {
    const cart = await fetchCartData(); // Ensure you have the latest cart data
    // console.log('cart:updated');
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: {
          cart,
        },
      })
    );
    // console.log('cart:refresh');
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart,
          source: 'embark-cart'
        },
      })
    );
    // Update the cart total on the page
    if (window.location.pathname === '/cart' && window.wholesale && cart.item_count !== window.wcp_data.wcp_cart.item_count) {
      window.location.reload()
      // console.log('Item Count Mistmach, refreshing')
    } else {
      // console.log('Cart updated and refreshed events dispatched with latest cart data.');
      if (window.location.pathname === '/cart') {
        await updateCartTotal(cart)
      }
      enableCheckoutButton()
    }
    // console.log('Cart', cart);
  } else {
    // console.log('Cart not fully synced, updates and refreshes withheld. Checking again.');
  }
}

function updateCartTotal(cart) {
  const cartTotalElement = document.querySelector('.cart__total-container');
  if (!window.wholesale) {
    const normalTotal = cartTotalElement.querySelector('.total-price')
    normalTotal.innerHTML = (cart.total_price / 100).toLocaleString('en-CA', { style: 'currency', currency: 'CAD' }) + '&nbsp;CAD';
  } else {
    const checkoutButton = document.querySelector('.cart__checkout-button')
    checkoutButton.classList.add('loading')

    const wcpCartOriginalTotal = cartTotalElement.querySelector('.wcp-original-cart-total')
    wcpCartOriginalTotal.innerHTML =  (window.wcp_data.wcp_cart.original_total_price / 100).toLocaleString('en-CA', { style: 'currency', currency: 'CAD' })

    const wcpCartTotal = cartTotalElement.querySelector('.wcp-cart-total')
    wcpCartTotal.innerHTML = Number(window.wcp_data.discounted_hash.wcp_total).toLocaleString('en-CA', { style: 'currency', currency: 'CAD' }) + '&nbsp;CAD'
    cartTotalElement.classList.remove('hiding')
  }

  // console.log('cart items', cart.items);
  // console.log('wcp items', window.wcp_data)

}

document.addEventListener('DOMContentLoaded', function () {
  clickShippingToggle();
  const addShipping = getShippingStatus();
  const formData = new FormData();
  formData.append(
    'attributes[include_shipping_insurance]',
    addShipping.toString()
  );
  updateCartItem(formData, '');
});
document.addEventListener('variant:added', () => {
  // console.log('variant:added');
  handleCartUpdates();
});
// document.addEventListener('line-item-quantity:change:start', () => {
//   // console.log('line-item-quantity:change:start');
//   disableCheckoutButtons();
// });
document.addEventListener('line-item-quantity:change:end', () => {
  // console.log('line-item-quantity:change:end');
  handleCartUpdates();
});
